import fetchClient, { ApiResponse } from '../api-client'
import { CheckCouponPayload } from './types/CheckCouponPayload'
import { CheckCouponResponse } from './types/CheckCouponResponse'
import { CreatePaymentLinkPayload } from './types/CreatePaymentLinkPayload'
import { CreateRPPaymentLinkPayload } from './types/CreateRPPaymentLinkPayload'
import { PkgPayment } from './types/PkgPayment'
import { RefundPaymentPayload } from './types/RefundPaymentPayload'
import { RefundPaymentResponse } from './types/RefundPaymentResponse'
import { TaxesData } from './types/TaxesData'

export const getPaymentLink = async (payload: CreatePaymentLinkPayload) => {
  const res = await fetchClient.post<ApiResponse<{ code: string; paymentMethod: string }>>('/payments/link', payload)
  return res.data.data
}

export const checkCoupon = async (payload: CheckCouponPayload): Promise<CheckCouponResponse> => {
  try {
    const res = await fetchClient.post<ApiResponse<CheckCouponResponse>>('/coupons/check', payload)
    return res.data.data
  } catch (error) {
    throw error
  }
}

export const getPkgTaxes = async (packageId: string) => {
  try {
    const reponse = await fetchClient.get<ApiResponse<{ response: TaxesData }>>(`/taxes/${packageId}`)
    // console.log("getPackageTaxes - reponse:", reponse)

    return reponse.data.data.response
  } catch (error) {
    console.log('getPackageTaxes - error:', error)
    throw error
  }
}

export const createPaymentLinkRP = async (payload: CreateRPPaymentLinkPayload): Promise<string> => {
  const res = await fetchClient.post<ApiResponse<string>>('/payments/getlink-returnPackage', payload)
  return res.data.data
}
export const refundPayment = async (payload: RefundPaymentPayload) => {
  const res = await fetchClient.post<ApiResponse<RefundPaymentResponse>>('/payments/packageRefund', payload)
  return res.data.data
}

export const cancelShipment = async (packageId: string) => {
  const res = await fetchClient.post<ApiResponse<{ refundAmount: number }>>('/payments/cancelShipment', { packageId })
  return res.data.data
}

export const getPkgPayments = async (packageId: string): Promise<PkgPayment[]> => {
  const res = await fetchClient.get<ApiResponse<PkgPayment[]>>(`/payments/pkg/${packageId}`)
  return res.data.data ?? []
}

export const TAX_FREE_THRESHOLD = 130
export const ID_REQUIRED_THRESHOLD = 150
